import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const InfoTooltip = ({ message, color = "#4A1476", iconSize = 16 }) => {
  return (
    <Tooltip
      title={message}
      placement="top"
      color={color}
      overlayInnerStyle={{ fontSize: "14px", padding: "10px" }}
      overlayStyle={{ zIndex: 100001 }}
      getPopupContainer={() => document.body}   // ✅ FIX
    >
      <InfoCircleOutlined
        style={{
          fontSize: iconSize,
          color: color,
          cursor: "pointer",
          marginLeft: "6px",
        }}
      />
    </Tooltip>
  );
};

export default InfoTooltip;
